import './Pagination-e98833e8.css';

var classes = {"Page":"prc-Pagination-Page-yoEQf","PaginationContainer":"prc-Pagination-PaginationContainer-yNDPO","TablePaginationSteps":"prc-Pagination-TablePaginationSteps-RRjtg"};

export { classes as default };
